"use strict";

module.exports = {
  mustard: '#ffd450',
  texas: '#ffb74c',
  tan: '#f8a34d',
  salmon: '#ff8863',
  bittersweet: '#ff7b76',
  sienna: '#ee805d',
  pinkie: '#ff78a7',
  charm: '#d45d8c',
  amethyst: '#bc71c9',
  helio: '#a381ff',
  lilac: '#8f75d1',
  malibu: '#7caeff',
  havelock: '#65a7e0',
  picton: '#4dc3f7',
  mint: '#4bd0e1',
  fountain: '#4eb6c2',
  puertorico: '#4fbdb2',
  bay: '#4da197',
  forest: '#73b077',
  york: '#81c785',
  feijoa: '#aed57f'
};